<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <search v-on:download="onDownload" v-on:searching="onSearch"></search>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-checkbox
                hide-details
                label="Enviar correos"
                primary
                v-model="form.sendEmails"
              ></v-checkbox>
              <v-btn @click="readyBag()" color="warning">valija lista</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-toolbar card color="white">
              <b>Tienes {{ form.invoices.length }} facturas seleccionadas.</b>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">
                    <v-checkbox
                      :disabled="props.item.checkCase == 'YES' ? true : false"
                      hide-details
                      v-model="props.selected"
                    ></v-checkbox>
                  </td>
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    <v-chip
                      :color="props.item.checkCase == 'YES' ? 'green' : 'red'"
                      label
                      small
                      text-color="white"
                    >
                      {{
                        props.item.checkCase == 'YES' ? 'LISTO' : 'SIN VALIJA'
                      }}
                    </v-chip>
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleDetails(props.item)" color="info"
                      >detalles</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-badge
                      :color="props.item.liquidated == 'YES' ? 'green' : 'grey'"
                      overlap
                    >
                      <span slot="badge">&nbsp;</span>
                    </v-badge>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              @input="asyncPagination"
              :total-visible="7"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :item="detail.data"
        :key="detail.key"
        v-on:close-detail="detail.show = false"
      ></compose>
    </v-dialog>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import compose from './../dialog/DialogDetails'
import loading from './../dialog/DialogLoading'
import search from './Search.vue'
import message from './../dialog/Message'
import SessionHelper from '@/helpers/SessionHelper'
export default {
  components: {
    compose,
    loading,
    search,
    message,
  },
  data() {
    return {
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      detail: {
        show: null,
        data: null,
        key: 0,
      },
      dialog: {
        show: null,
        key: 0,
      },
      form: {
        invoices: [],
        sendEmails: false,
      },
      complex: {
        selected: [],
        headers: [
          {
            text: '',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Facturas',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Estado',
            align: 'left',
            sortable: false,
          },
          {
            text: 'Detalles',
            align: 'center',
            sortable: false,
          },
          {
            text: 'Pagos',
            align: 'center',
            sortable: false,
          },
        ],
      },
    }
  },
  watch: {
    'complex.selected': function(val) {
      this.form.invoices = []
      Object.keys(val).map(objectKey => {
        this.form.invoices.push(val[objectKey].id)
      })
    },
  },
  computed: {
    ...mapState({
      invoices: state => state.invoices.all,
    }),
  },
  created() {
    this.asyncPagination()
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store.dispatch('invoices/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            data: { ...row, products: items ? items : null },
            show: true,
            key: this.detail.key + 1,
          }
        })
    },
    readyBag() {
      if (this.form.invoices.length > 0) {
        this.loading = true
        this.$store.dispatch('transit/caseReady', this.form).then(() => {
          this.complex.selected = []
          this.asyncPagination()
        })
      }
    },
    onSearch(params) {
      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>
